import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class RestService {
    constructor(private readonly http: HttpClient) {}

    async geocode(address: string, cityCode: string | undefined) {
        const banUrl = `https://data.geopf.fr/geocodage/search?q=${address}&citicode=${cityCode}`;

        return await firstValueFrom(this.http.get(banUrl.replaceAll(' ', '%20')));
    }

    download(path: string, parameters?: { [key: string]: any }): Observable<Object> {
        const apiUrl = environment.apiUrl;
        const params = this._setParams(parameters || {});
        const url = apiUrl + path;
        return this.http.get(url, { params, responseType: 'blob' });
    }

    get(path: string, parameters?: { [key: string]: any }): Promise<any> {
        return this._send('GET', path, parameters || {});
    }

    put(path: string, parameters?: { [key: string]: any }, data?: any): Promise<any> {
        return this._send('PUT', path, parameters || {}, data);
    }

    delete(path: string, parameters?: { [key: string]: any }): Promise<any> {
        return this._send('DELETE', path, parameters || {});
    }

    post(path: string, parameters?: { [key: string]: any }, data?: any): Promise<any> {
        return this._send('POST', path, parameters || {}, data);
    }
    patch(path: string, parameters?: { [key: string]: any }, data?: any): Promise<any> {
        return this._send('PATCH', path, parameters || {}, data);
    }

    private async _send(
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
        path: string,
        parameters: { [key: string]: any },
        data?: any,
    ): Promise<any> {
        const apiUrl = environment.apiUrl;
        const params = this._setParams(parameters);
        const url = apiUrl + path;
        let promise: Observable<any>;
        if (method === 'GET') {
            promise = this.http.get(url, { params });
        } else if (method === 'DELETE') {
            promise = this.http.delete(url, { params });
        } else if (method === 'PUT') {
            promise = this.http.put(url, data, { params });
        } else if (method === 'PATCH') {
            promise = this.http.patch(url, data, { params });
        } else {
            promise = this.http.post(url, data, { params });
        }

        try {
            const result = await lastValueFrom(promise);
            return result;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    private _setParams(parameters: { [key: string]: any }): HttpParams {
        const tmpArray = [];
        const params = new HttpParams({ fromObject: parameters });
        return params;
    }
}
